import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Breadcrumbs,
  Link as MuiLink,
  TextField,
  InputAdornment,
  Fade,
  Slide,
  Avatar,
  Button
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ShoppingCart as ShoppingCartIcon,
  LocalShipping as ShippingIcon,
  Payment as PaymentIcon,
  AccountCircle as AccountIcon,
  Store as StoreIcon,
  Security as SecurityIcon,
  Help as HelpIcon,
  NavigateNext as NavigateNextIcon,
  Search as SearchIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Chat as ChatIcon,
  QuestionAnswer as QuestionAnswerIcon,
  LiveHelp as LiveHelpIcon,
  Support as SupportIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Help = () => {
  const [expanded, setExpanded] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const faqSections = [
    {
      title: 'অর্ডার এবং পেমেন্ট',
      icon: <ShoppingCartIcon />,
      questions: [
        {
          q: 'কিভাবে অর্ডার করব?',
          a: 'আপনি পণ্য বেছে নিয়ে কার্টে যোগ করুন, তারপর চেকআউট করুন। আপনার ঠিকানা এবং পেমেন্ট তথ্য দিন। আমাদের সহজ অর্ডার প্রক্রিয়া অনুসরণ করে মাত্র কয়েক মিনিটেই আপনার অর্ডার সম্পন্ন করতে পারবেন।'
        },
        {
          q: 'কি কি পেমেন্ট মাধ্যম গ্রহণ করা হয়?',
          a: 'আমরা বিকাশ, নগদ, রকেট, উপায়, ক্যাশ অন ডেলিভারি (COD), ভিসা এবং মাস্টারকার্ড গ্রহণ করি। সকল পেমেন্ট সম্পূর্ণ নিরাপদ এবং এনক্রিপ্টেড।'
        },
        {
          q: 'অর্ডার ক্যান্সেল করতে চাই, কিভাবে করব?',
          a: 'আপনার অ্যাকাউন্টে গিয়ে অর্ডার হিস্টরি থেকে ক্যান্সেল করতে পারবেন। অর্ডার প্রসেসিং শুরু হওয়ার আগে পর্যন্ত ক্যান্সেল করা যাবে।'
        },
        {
          q: 'অর্ডার ট্র্যাক করব কিভাবে?',
          a: 'অর্ডার করার পর আপনি একটি ট্র্যাকিং নম্বর পাবেন। এই নম্বর দিয়ে আমাদের ওয়েবসাইটে বা অ্যাপে আপনার অর্ডারের অবস্থা দেখতে পারবেন।'
        }
      ]
    },
    {
      title: 'ডেলিভারি',
      icon: <ShippingIcon />,
      questions: [
        {
          q: 'ডেলিভারি সময় কত?',
          a: 'ঢাকার ভিতরে ২৪-৪৮ ঘন্টা, ঢাকার বাইরে ৩-৫ দিন। জরুরি ডেলিভারির জন্য এক্সপ্রেস ডেলিভারি সেবা রয়েছে।'
        },
        {
          q: 'ডেলিভারি চার্জ কত?',
          a: 'ঢাকার ভিতরে ৬০ টাকা, ঢাকার বাইরে ১২০ টাকা। ২০০০ টাকার বেশি অর্ডারে সম্পূর্ণ ফ্রি ডেলিভারি।'
        },
        {
          q: 'এক্সপ্রেস ডেলিভারি কি?',
          a: 'এক্সপ্রেস ডেলিভারিতে ঢাকার ভিতরে ৬-১২ ঘন্টার মধ্যে পণ্য পৌঁছে দেওয়া হয়। অতিরিক্ত চার্জ প্রযোজ্য।'
        }
      ]
    },
    {
      title: 'রিটার্ন এবং রিফান্ড',
      icon: <PaymentIcon />,
      questions: [
        {
          q: 'পণ্য রিটার্ন করতে চাই, কিভাবে করব?',
          a: 'ডেলিভারির ৭ দিনের মধ্যে পণ্য রিটার্ন করা যাবে। অ্যাকাউন্টে গিয়ে রিটার্ন রিকোয়েস্ট করুন। পণ্য অবশ্যই অব্যবহৃত এবং মূল প্যাকেজিংয়ে থাকতে হবে।'
        },
        {
          q: 'রিফান্ড কত দিনে পাব?',
          a: 'রিটার্ন গ্রহণ করার ৭-১০ কার্যদিবসের মধ্যে রিফান্ড প্রক্রিয়া সম্পন্ন হয়। মোবাইল ব্যাংকিংয়ে ২-৩ দিন, ব্যাংক অ্যাকাউন্টে ৫-৭ দিন সময় লাগে।'
        },
        {
          q: 'কোন পণ্য রিটার্ন করা যায় না?',
          a: 'খাদ্যপণ্য, ব্যক্তিগত স্বাস্থ্য পণ্য, কাস্টমাইজড পণ্য এবং কিছু ইলেকট্রনিক্স পণ্য রিটার্ন করা যায় না।'
        }
      ]
    },
    {
      title: 'অ্যাকাউন্ট এবং নিরাপত্তা',
      icon: <SecurityIcon />,
      questions: [
        {
          q: 'অ্যাকাউন্ট তৈরি করব কিভাবে?',
          a: 'সাইন আপ বাটনে ক্লিক করে আপনার ইমেইল বা ফোন নম্বর দিয়ে অ্যাকাউন্ট তৈরি করুন। ভেরিফিকেশন কোড দিয়ে অ্যাকাউন্ট সক্রিয় করুন।'
        },
        {
          q: 'পাসওয়ার্ড ভুলে গেছি, কি করব?',
          a: 'লগইন পেজে "পাসওয়ার্ড ভুলে গেছেন?" লিংকে ক্লিক করুন। আপনার ইমেইল বা ফোনে রিসেট লিংক পাবেন।'
        },
        {
          q: 'আমার তথ্য কতটা নিরাপদ?',
          a: 'আমরা আন্তর্জাতিক মানের নিরাপত্তা ব্যবস্থা ব্যবহার করি। আপনার সকল তথ্য এনক্রিপ্টেড এবং সুরক্ষিত।'
        }
      ]
    }
  ];

  const helpCategories = [
    {
      title: 'অর্ডার ট্র্যাকিং',
      icon: <ShoppingCartIcon sx={{ fontSize: 40 }} />,
      description: 'আপনার অর্ডার স্ট্যাটাস দেখুন এবং ট্র্যাক করুন',
      color: '#4CAF50'
    },
    {
      title: 'শিপিং পলিসি',
      icon: <ShippingIcon sx={{ fontSize: 40 }} />,
      description: 'ডেলিভারি সময় এবং চার্জ সম্পর্কে জানুন',
      color: '#2196F3'
    },
    {
      title: 'পেমেন্ট অপশন',
      icon: <PaymentIcon sx={{ fontSize: 40 }} />,
      description: 'সকল পেমেন্ট মাধ্যম এবং নিরাপত্তা',
      color: '#FF9800'
    },
    {
      title: 'অ্যাকাউন্ট সেটিংস',
      icon: <AccountIcon sx={{ fontSize: 40 }} />,
      description: 'প্রোফাইল এবং অ্যাকাউন্ট পরিচালনা',
      color: '#9C27B0'
    },
    {
      title: 'সেলার সেন্টার',
      icon: <StoreIcon sx={{ fontSize: 40 }} />,
      description: 'বিক্রেতাদের জন্য গাইড এবং সাপোর্ট',
      color: '#F44336'
    },
    {
      title: 'নিরাপত্তা',
      icon: <SecurityIcon sx={{ fontSize: 40 }} />,
      description: 'অ্যাকাউন্ট এবং পেমেন্ট নিরাপত্তা',
      color: '#607D8B'
    }
  ];

  const supportOptions = [
    {
      title: 'লাইভ চ্যাট',
      description: 'তাৎক্ষণিক সাহায্য পান',
      icon: <ChatIcon />,
      action: 'চ্যাট শুরু করুন',
      color: '#4CAF50'
    },
    {
      title: 'ফোন সাপোর্ট',
      description: '+880 1234 567890',
      icon: <PhoneIcon />,
      action: 'কল করুন',
      color: '#2196F3'
    },
    {
      title: 'ইমেইল সাপোর্ট',
      description: 'support@grameenbazar.com',
      icon: <EmailIcon />,
      action: 'ইমেইল পাঠান',
      color: '#FF9800'
    }
  ];

  // Filter FAQs based on search query
  const filteredFAQs = faqSections.map(section => ({
    ...section,
    questions: section.questions.filter(
      faq => 
        faq.q.toLowerCase().includes(searchQuery.toLowerCase()) ||
        faq.a.toLowerCase().includes(searchQuery.toLowerCase())
    )
  })).filter(section => section.questions.length > 0);

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
        {/* Hero Section */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            py: 8,
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Container>
            <Breadcrumbs 
              separator={<NavigateNextIcon fontSize="small" />} 
              aria-label="breadcrumb"
              sx={{ mb: 4, '& .MuiBreadcrumbs-separator': { color: 'rgba(255,255,255,0.7)' } }}
            >
              <MuiLink component={Link} to="/" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                হোম
              </MuiLink>
              <Typography sx={{ color: 'white' }}>সাহায্য</Typography>
            </Breadcrumbs>

            <Fade in timeout={1000}>
              <Box sx={{ textAlign: 'center', mb: 6 }}>
                <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
                  কিভাবে সাহায্য করতে পারি?
                </Typography>
                <Typography variant="h5" sx={{ opacity: 0.9, maxWidth: '600px', mx: 'auto', mb: 4 }}>
                  আপনার যেকোনো প্রশ্নের উত্তর পেতে নিচের বিভাগগুলো দেখুন
                </Typography>

                {/* Search Box */}
                <Box sx={{ maxWidth: '500px', mx: 'auto' }}>
                  <TextField
                    fullWidth
                    placeholder="আপনার প্রশ্ন লিখুন..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: 'rgba(0,0,0,0.6)' }} />
                        </InputAdornment>
                      ),
                      sx: {
                        bgcolor: 'white',
                        borderRadius: 3,
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: 'none'
                        }
                      }
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        py: 2
                      }
                    }}
                  />
                </Box>
              </Box>
            </Fade>
          </Container>
        </Box>

        <Container sx={{ py: 6 }}>
          {/* Help Categories */}
          <Box sx={{ mb: 8 }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              সাহায্যের বিভাগসমূহ
            </Typography>
            <Grid container spacing={3}>
              {helpCategories.map((category, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Slide direction="up" in timeout={500 + index * 100}>
                    <Card 
                      sx={{ 
                        height: '100%',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-8px)',
                          boxShadow: '0 12px 24px rgba(0,0,0,0.15)'
                        },
                        border: '1px solid #e2e8f0'
                      }}
                    >
                      <CardActionArea sx={{ height: '100%', p: 3 }}>
                        <CardContent sx={{ textAlign: 'center', p: 0 }}>
                          <Avatar
                            sx={{
                              bgcolor: category.color,
                              width: 80,
                              height: 80,
                              mx: 'auto',
                              mb: 3
                            }}
                          >
                            {category.icon}
                          </Avatar>
                          <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 600 }}>
                            {category.title}
                          </Typography>
                          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                            {category.description}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Slide>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* FAQ Sections */}
          <Box sx={{ mb: 8 }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              সাধারণ জিজ্ঞাসা
            </Typography>
            
            {(searchQuery ? filteredFAQs : faqSections).map((section, sectionIndex) => (
              <Fade in timeout={800 + sectionIndex * 200} key={sectionIndex}>
                <Box sx={{ mb: 4 }}>
                  <Paper sx={{ p: 4, mb: 3, bgcolor: 'white', border: '1px solid #e2e8f0' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
                        {section.icon}
                      </Avatar>
                      <Typography variant="h4" sx={{ fontWeight: 600 }}>
                        {section.title}
                      </Typography>
                    </Box>
                    
                    {section.questions.map((faq, faqIndex) => (
                      <Accordion
                        key={faqIndex}
                        expanded={expanded === `panel${sectionIndex}-${faqIndex}`}
                        onChange={handleChange(`panel${sectionIndex}-${faqIndex}`)}
                        sx={{ 
                          mb: 2,
                          border: '1px solid #e2e8f0',
                          borderRadius: 2,
                          '&:before': { display: 'none' },
                          boxShadow: 'none'
                        }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`panel${sectionIndex}-${faqIndex}-content`}
                          id={`panel${sectionIndex}-${faqIndex}-header`}
                          sx={{
                            bgcolor: '#f8fafc',
                            borderRadius: 2,
                            '&.Mui-expanded': {
                              borderBottomLeftRadius: 0,
                              borderBottomRightRadius: 0
                            }
                          }}
                        >
                          <Typography variant="h6" sx={{ fontWeight: 500 }}>
                            {faq.q}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 3, bgcolor: 'white' }}>
                          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                            {faq.a}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Paper>
                </Box>
              </Fade>
            ))}

            {searchQuery && filteredFAQs.length === 0 && (
              <Paper sx={{ p: 6, textAlign: 'center' }}>
                <QuestionAnswerIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
                <Typography variant="h5" gutterBottom>
                  কোনো ফলাফল পাওয়া যায়নি
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  আপনার প্রশ্নের জন্য আমাদের সাথে সরাসরি যোগাযোগ করুন
                </Typography>
              </Paper>
            )}
          </Box>

          {/* Support Options */}
          <Box sx={{ mb: 6 }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              সরাসরি সাহায্য পান
            </Typography>
            <Grid container spacing={4}>
              {supportOptions.map((option, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Slide direction="up" in timeout={1000 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 4,
                        height: '100%',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                        },
                        border: '1px solid #e2e8f0'
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: option.color,
                          width: 64,
                          height: 64,
                          mx: 'auto',
                          mb: 3
                        }}
                      >
                        {option.icon}
                      </Avatar>
                      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                        {option.title}
                      </Typography>
                      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        {option.description}
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{
                          bgcolor: option.color,
                          '&:hover': {
                            bgcolor: option.color,
                            filter: 'brightness(0.9)'
                          }
                        }}
                      >
                        {option.action}
                      </Button>
                    </Card>
                  </Slide>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Contact Support CTA */}
          <Paper
            sx={{
              p: 6,
              textAlign: 'center',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              borderRadius: 3
            }}
          >
            <SupportIcon sx={{ fontSize: 64, mb: 2, opacity: 0.9 }} />
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
              এখনও প্রশ্ন আছে?
            </Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>
              আমাদের সাপোর্ট টিম ২৪/৭ আপনার সেবায় নিয়োজিত
            </Typography>
            <Button
              variant="contained"
              size="large"
              component={Link}
              to="/contact"
              sx={{
                bgcolor: 'white',
                color: 'primary.main',
                px: 4,
                py: 1.5,
                fontWeight: 600,
                '&:hover': {
                  bgcolor: 'grey.100'
                }
              }}
            >
              যোগাযোগ করুন
            </Button>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default Help; 